export const fixHangingPrepositions = (str) => {
  let res = str;
  if (res && typeof (res) === 'string') {
    const smallWordsPattern = '(к|в|и|а|на|из|у|с|о|со|от|за|вы|при|им|по|не|об|г.|через|для|чтобы)';
    res = res.replace(new RegExp(`^${smallWordsPattern}\\s`, 'gi'), '$1\u00a0');
    res = res.replace(new RegExp(`\\s${smallWordsPattern}\\s`, 'gi'), ' $1\u00a0');
    res = res.replace(new RegExp(`\\u00a0${smallWordsPattern}\\s`, 'gi'), '\u00a0$1\u00a0');
    res = res.replace(/\s([^.,\-?!]) (АТИ)\s/gi, '$1\u00a0$2');
  }
  return res;
};

function makeHandlers() {
  const propsCache = new Map();

  return {
    get(target, prop) {
      const propValue = target[prop];
      if (!propValue) {
        return propValue;
      }

      if (!propsCache.has(prop)) {
        const cachedValue = typeof (propValue) === 'function'
          ? (...args) => fixHangingPrepositions(propValue.call(this, args))
          : fixHangingPrepositions(propValue);
        propsCache.set(prop, cachedValue);
      }

      return propsCache.get(prop);
    },
  };
}

function unhangPrepositions(stringsObject) {
  if (typeof (Proxy) === 'undefined') {
    return stringsObject;
  }

  return new Proxy(stringsObject, makeHandlers());
}

export default unhangPrepositions;
